<template>
	<div id="ioArchControls">

		<img data-toggle="collapse" data-target="#intraoralArchPanel" aria-expanded="false" title="Arch Measure Panel"
			src="images/menu_white.png" class="io-arch-panel-btn" />

		<!-- <div id="ioArchShowLinesDiv" class="toggle-div" v-on:click.stop="setShowLines($event)">
			<input id="ioArchShowLinesButton" type="checkbox" />
			<div id="ioArchShowLinesTitle" class="toggle-title"
				v-bind:style="{ color: isWhite ? blueColor : whiteColor }">Show Measure Lines</div>
		</div>

		<div id="ioArchSymmPointsDiv" class="toggle-div" v-on:click.stop="setSymmPoints($event)">
			<input id="ioArchSymmPointsButton" type="checkbox" checked />
			<div id="ioArchSymmPointsTitle" class="toggle-title"
				v-bind:style="{ color: isWhite ? blueColor : whiteColor }">Move Points Symmetricallly</div>
		</div>

		<button class="arch-button arch-export-button" v-on:click="exportReportClick()">
			EXPORT REPORT
		</button>

		<button class="arch-button arch-save-button" v-on:click="exitModeClick(true)">
			SAVE
		</button>

		<button class="arch-button arch-cancel-button" v-on:click="exitModeClick(false)">
			CANCEL
		</button> -->
	</div>
</template>

<script>

import { switchShowLines, leaveArchMode, exportReport } from "./IntraoralArchMode.js";

export default {
	name: "IntraoralArchControls",
	props: ["editContext"],
	components: {},
	methods: {
		setShowLines: function (event) {
			this.editContext.showLines = !this.editContext.showLines;
			if (event) {
				switchToggle(event.currentTarget.id, this.editContext.showLines);
			}
			switchShowLines(this.editContext.showLines);
		},
		setSymmPoints: function (event) {
			this.editContext.symmPoints = !this.editContext.symmPoints;
			if (event) {
				switchToggle(event.currentTarget.id, this.editContext.symmPoints);
			}

		},
		exportReportClick: function () {
			exportReport();
		},
		exitModeClick: function (saveChanges) {
			leaveArchMode(saveChanges);
		}
	},
	mounted: function () {
		canecode_switch("#ioArchSymmPointsButton");
		canecode_switch("#ioArchShowLinesButton");
	}
};

</script>

<style scoped>
#ioArchControls {
	position: absolute;
	cursor: pointer;
	z-index: 9;
	top: 56px;
	right: 79px;
	/* left: calc(50% - 200px);
	bottom: 75px;
	display: none;
	width: 400px;
	height: 70px;
	position: absolute; */
}

.io-arch-panel-btn {
	/* cursor: pointer;
	position: absolute;
	top: 50px;
	left: 14px; */
	width: 30px;
	height: 30px;
}

#ioArchLabel {
	width: 209px;
	/* margin-left: -40px; */
	left: calc(50% - 84px);
	text-align: center;
	color: #ffffff;
	position: absolute;
	bottom: 35px;
}

.arch-button {
	position: absolute;
	bottom: 0;
	display: inline-block;
	min-width: 90px;
	width: auto;
	height: 35px;
	border: 0;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	/*#F7FAFF;*/
	text-align: center;
	color: #ffffff;
	z-index: 99;
}

.arch-export-button {
	left: calc(50% - 135px);
}

.arch-save-button {
	left: calc(50% - 1px);
}

.arch-cancel-button {
	left: calc(50% + 99px);
}

.toggle-div {
	bottom: 50px;
	position: absolute;
	text-align: center;
	z-index: 9;
	color: #ffffff;
	width: auto;
}

.toggle-title {
	font-size: medium;
	font-weight: normal;
	width: 150px;
}

#ioArchSymmPointsDiv {
	left: calc(50% - 90px);
}

#ioArchShowLinesDiv {
	left: calc(50% + 60px);
}

#ioArchSymmPointsTitle {
	margin-left: -30px;
}

#ioArchShowLinesTitle {
	margin-left: -40px;
}
</style>